export interface IsAuthenticatedOptions {
  redirect_uri?: string;
}

/**
 * Sample error:
 * {
 *    "error": "missing_refresh_token",
 *    "error_description": "Missing Refresh Token (audience: 'https://api.panoptyc.co', scope: 'openid profile email offline_access')",
 *    "audience": "https://api.panoptyc.co",
 *    "scope": "openid profile email offline_access"
 * }
 */
export interface Auth0Error {
  /** `string` is part of type because we don't handle the other errors yet */
  error: KnownAuthErrorTypes | string;
  error_description: string;
  // these properties are not always included (e.g. "Invalid state")
  audience?: string;
  scope?: string;
}

export interface IAuthorizationParams {
  redirect_uri?: string;
  client_id: string;
  prompt?: 'none' | 'login' | 'consent' | 'select_account';
}

export enum Auth0Connections {
  Email = 'email',
  GoogleOAuth2 = 'google-oauth2',
  UsernamePasswordAuthentication = 'Username-Password-Authentication',
}

export enum KnownAuthErrorTypes {
  MissingRefreshToken = 'missing_refresh_token',
  InvalidGrant = 'invalid_grant',
  // this seems to be paired with "Invalid state"
  MissingTransaction = 'missing_transaction',
  // this is also paired with "Invalid state"
  StateMismatch = 'state_mismatch',
  InvalidRequest = 'invalid_request',
}

export enum KnownAuthErrorDescriptions {
  // reference for what to do if this persists:
  // https://community.auth0.com/t/invalid-state-on-reload-auth0-callback-url-using-auth0-spa-js-and-angular-8/36469/10
  InvalidState = 'Invalid state',
}

export const LoginQueryParams = {
  RETURN_URL: 'returnUrl',
} as const;
